import { context, utils } from '@ad-engine/core';

const logGroup = 'UID2';

class UID2 {
	private readonly subscriptionId = 'VCaqxS6v2X';
	private readonly serverPublicKey =
		'UID2-X-P-MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEOE+DsIa2aJWHIYpG+JrLpe0uxwrGe9aC4NaP7lQMN9+9/pk/7vydOrzQvxeDSlThIiMwGRMpyjAa593RYoGtFA==';

	getConfig(hem: string): object | undefined {
		if (!this.isEnabled() || !hem) {
			utils.logger(logGroup, 'disabled');
			return;
		}

		return {
			name: 'uid2',
			params: {
				serverPublicKey: this.serverPublicKey,
				subscriptionId: this.subscriptionId,
				emailHash: utils.base64.hexToBase64(hem),
			},
		};
	}

	isEnabled(): boolean {
		return (
			context.get('bidders.prebid.uid2') &&
			context.get('options.trackingOptIn') &&
			!context.get('options.optOutSale') &&
			!utils.isCoppaSubject()
		);
	}
}

export const uid2 = new UID2();
